import { addLabelArray } from "helpers/addLabelArray";
import { formatCustomDate } from "helpers/dateTools";
import { PROYECT, api_get } from "services/api";
import { setSnackbar } from "redux/actions/search/searchActions";

const baseUrl = process.env.REACT_APP_URL;

export const handleFetchCustomers = async (
  search = "",
  stationId = "",
  unitType = "",
  stations = null,
  handleValues
) => {
  if (!search) return;
  const getCustomersUrl =
    stationId.length > 0
      ? `${baseUrl}${PROYECT}/customers?stations=${stationId}&filter=${search}`
      : `${process.env.REACT_APP_URL}${PROYECT}/customers?filter=${search}`;
  const data = await api_get(getCustomersUrl);
  const response = data.reduce((acc, curr) => {
    acc.push(
      ...curr.accounts.map((account) => ({
        idCustomer: curr.id,
        rfc: curr.rfc,
        idMunicipality: curr.address?.idMunicipality,
        discount: curr.discount,
        isCredit: curr.isCredit,
        accountCode: account.code,
        ...account,
      }))
    );
    return acc;
  }, []);
  let filterAccounts = [];
  const wordsPublicAccount = search
    .split(" ")
    .map((word) => word.toLowerCase());
  if (stationId.length > 0) {
    filterAccounts = response.filter(
      (account) => account.idStation === stationId && account.type === unitType
    );
  } else if (wordsPublicAccount.includes("publico")) {
    filterAccounts = response.filter(
      (account) => account.accountCode === "999"
    );
    handleValues({ searchCustomer: "" });
  } else {
    filterAccounts = response;
  }

  const labelResponse = filterAccounts.map((acc) => {
    return {
      ...acc,
      label: `${acc.alias} - ${acc.phone || acc.localPhone || acc.code} ${stations ? "-" : ""
        } ${stations ? stations[acc.idStation]?.label : ""} ${stations ? "-" : ""
        } ${stations ? acc.type : ""}`,
    };
  });

  return labelResponse;
};

export const handleFetchPublicCustomers = async (
  idStation,
  priceType,
  setSnackbar
) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/accounts/general-public/station-type?station=${idStation}&priceType=${priceType}`;

  const response = await api_get(url);
  const labelResponse = response.map((acc) => {
    !acc.address.idMunicipality &&
      setSnackbar("El id del municipio no existe", "danger");
    return {
      accountCode: acc.code,
      accountType: acc.type,
      alias: acc.alias,
      customerCode: acc.customer.code,
      idAccount: acc.id,
      idCustomer: acc.customer.id,
      idMunicipality: acc?.address?.idMunicipality,
      label: `${acc.alias} - ${acc.phone || acc.localPhone || acc.code}`,
      value: acc.id,
      idStation: acc.idStation,
      phone: acc.phone || acc.localPhone,
    };
  });
  return labelResponse;
};

export const handleFetchSalesAccountDetails = async (date = "", id = "") => {
  if (!date || !id) return;
  const params = `?date=${formatCustomDate(date, "-")}&account=${id}`;
  const getSalesAccountDetailsUrl = `${baseUrl}${PROYECT}/notes/manual/detail-by-date-and-account${params}`;
  const data = await api_get(getSalesAccountDetailsUrl);
  return data;
};

export const handleFetchCustomerPublic = async (
  search = "",
  stationId = "",
  setValues
) => {
  if (!search) return;
  const getCustomersUrl =
    stationId.length > 0
      ? `${baseUrl}${PROYECT}/customers?stations=${stationId}&filter=${search}`
      : `${process.env.REACT_APP_URL}${PROYECT}/customers?filter=${search}`;
  const data = await api_get(getCustomersUrl);
  const response = data
    .filter((acc) => acc.code === "999" && acc.idStation === stationId)
    .map((cus) => {
      return {
        ...cus,
        value: cus.id,
        label: `${cus.name} - ${cus.code}`,
      };
    });
  response.length === 1 && setValues({ idCustomer: response[0] });
  setValues({ customersOpt: response });
  return response;
};

export const handleFetchCustomersLessData = async (stations, customer) => {
  try {
    const getCustomersUrl = `${baseUrl}/search-less-data/${stations}?filter=${customer}`;
    const data = await api_get(getCustomersUrl);
    const labelResponse = addLabelArray(data, "name", "code");
    return labelResponse;
  } catch (error) {
    console.error(error);
  }
};

export const handleUltimateFetchLessData = async (
  stations = [],
  search = "",
  sta = {},
  setValues,
  filterStationId = "",
  filterCustomerCode = ""
) => {
  try {
    const params = stations
      .map((station) => `stations=${station.id}`)
      .join("&");

    const url = `${process.env.REACT_APP_URL}${PROYECT}/accounts/search-less-data?${params}&filter=${search}`;
    let response = null;
    response = await api_get(url);
    if (response) {
      const responseStationLabel = response.map((item) => {
        return {
          ...item,
          value: item.idAccount,
          label: `${item?.consecutive ? item?.consecutive : ""} ${item.alias
            } - ${item.accountCode || "Sin Codigo"} - ${sta[(item?.idStation)]?.label
            } - ${item.accountType}  ${!item.idMunicipality ? "- ( Sin Municipio )" : ""
            } `,
        };
      });
      let values = [];
      if (search.toLowerCase().includes("publico")) {
        values = responseStationLabel.filter(
          (item) => item.accountCode === "999"
        );
      } else {
        values = responseStationLabel;
      }

      if (filterStationId.length > 0) {
        values = values.filter((item) => item.idStation === filterStationId);
      }

      if (filterCustomerCode.length > 0) {
        values = values.filter((item) =>
          item.customerCode.includes(filterCustomerCode)
        );
      }

      setValues({
        customersOpt: values,
      });
    }
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const handleFetchLessDataOneStation = async (
  stations = null,
  search = "",
  sta = {},
  setValues,
  filterStationId = ""
) => {
  try {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/accounts/search-less-data?stations=${stations.id}&filter=${search}`;
    let response = null;
    response = await api_get(url);
    if (response) {
      const responseStationLabel = response.map((item) => {
        return {
          ...item,
          value: item.idAccount,
          label: `${item?.consecutive ? item?.consecutive : ""} ${item.alias
            } - ${item.accountCode || "Sin Codigo"} - ${sta[(item?.idStation)]?.label
            } - ${item.accountType}  ${!item.idMunicipality ? "- ( Sin Municipio )" : ""
            } `,
        };
      });
      let values = [];
      if (search.toLowerCase().includes("publico")) {
        values = responseStationLabel.filter(
          (item) => item.accountCode === "999"
        );
      } else {
        values = responseStationLabel;
      }

      if (filterStationId.length > 0) {
        values = values.filter((item) => item.idStation === filterStationId);
      }

      setValues({
        customersOpt: values,
      });
    }
    return response;
  } catch (error) {
    console.error(error);
  }
}

export const handleRfcData = async (rfc = "", setValues = null, dispatch = null, setFieldErrors = null) => {
  try {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/fiscal-customers/rfc/${rfc}`
    let response = null
    response = await api_get(url);
    if (response) {
      const responseLabel = {
        ...response,
        value: response.id,
        label: `${response?.name} ${response.rfc} - ${response.postalCode}`,
      }
      
      setValues && setValues({
        idAccount: responseLabel,
        searchCustomer: responseLabel.label
      })
    }
    return response;
  } catch (error) {
    setFieldErrors && setFieldErrors({ searchCustomer: error?.message || "Error al obtener el cliente" });
    dispatch && dispatch(setSnackbar(error));
    return null;
  }
}
